import { GET_SCR_REPORT } from '../../../Types'

const SCRReportReducer = (state = [], action) => {
    switch (action.type) {
        case GET_SCR_REPORT:
            return action.payload
        default:
            return state
    }
}
export default SCRReportReducer